import type { FC } from 'react';

import { typographyClassName } from '@creditornot/cb-ingredients';
import { clsx } from '@creditornot/cb-utils';

import { Heading } from './Heading';

const typographyComponent = (displayName: string, typographyClassName: string) => {
  const Component: FC<React.HTMLProps<HTMLSpanElement>> = ({ children, className, ...rest }) => (
    <span className={clsx(typographyClassName, className)} {...rest}>
      {children}
    </span>
  );
  Component.displayName = displayName;

  return Component;
};

const Typography = {
  Heading,
  subheadline: typographyComponent('subheadline', typographyClassName.subheadline),
  caption: typographyComponent('caption', typographyClassName.caption),
  captionLabel: typographyComponent('captionLabel', typographyClassName.captionLabel),
  captionLink: typographyComponent('captionLink', typographyClassName.captionLink),
  body: typographyComponent('body', typographyClassName.body),
  bodyLabel: typographyComponent('bodyLabel', typographyClassName.bodyLabel),
  bodyLink: typographyComponent('bodyLink', typographyClassName.bodyLink),
  footnote: typographyComponent('footnote', typographyClassName.footnote),
  footnoteLabel: typographyComponent('footnoteLabel', typographyClassName.footnoteLabel),
  footnoteLink: typographyComponent('footnoteLink', typographyClassName.footnoteLink),
};

export { Typography };
